import baseStyles from "../../toolbox.module.css";
import { BasicToolboxProps, Toolbox } from "../../toolbox";
import { usePosterProject } from "PosterEditor/model/poster-project-provider";
import { ToolboxComponentSlider } from "../../toolbox-components/toolbox-component-slider";
import { ToolboxComponentColorPicker } from "../../toolbox-components/toolbox-component-color-picker";
import { pickerColors } from "PosterEditor/model/poster-project";
import {
  ToolboxComponentSection as Section,
  ToolboxSectionDivider as Divider,
} from "../../toolbox-components/toolbox-component-section";
import { useState } from "react";
import { useSizePresets } from "PosterEditor/model/size-presets/size-preset";

interface ToolboxBorderStyleProps extends BasicToolboxProps {}

export const ToolboxBorderStyle = (props: ToolboxBorderStyleProps) => {
  return (
    <Toolbox
      title="Border"
      collapsible={props.collapsible}
      isCollapsed={props.isCollapsed}
      onToggleCollapse={props.onToggleCollapse}
    >
      <div className={baseStyles.paddedBodyContent}>
        <Section>
          <BorderWidth />
        </Section>
        <Divider />
        <Section>
          <BorderColor />
        </Section>
      </div>
    </Toolbox>
  );
};

interface BorderWidthProps {}
const BorderWidth = (props: BorderWidthProps) => {
  const { project, setBorderWidthMM } = usePosterProject();
  const { nearestIncrementValueToValue, incrementSizeInMM } = useSizePresets();
  const onChangeBorderWidth = (valueInMM: number) => {
    const snapped = nearestIncrementValueToValue(valueInMM, incrementSizeInMM);
    setBorderWidthMM(snapped);
  };

  return (
    <ToolboxComponentSlider
      title="Width"
      meta={`${(project.borderStyle.borderWidth ?? 0) / 10} cm`}
      min={0}
      max={50}
      value={project.borderStyle.borderWidth ?? 0}
      onChange={onChangeBorderWidth}
    />
  );
};

interface BorderColorProps {}
const BorderColor = (props: BorderColorProps) => {
  const { project, setBorderColor } = usePosterProject();
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <ToolboxComponentColorPicker
      title="Color"
      isExpanded={isExpanded}
      colors={pickerColors}
      showSwatch={true}
      selectedColor={project.borderStyle.borderColor ?? "#FFFFFFF"}
      onSelectColor={setBorderColor}
      onToggleExpand={() => setIsExpanded(!isExpanded)}
    />
  );
};
